export default __webpack_public_path__ + "static/media/sugar_free.66fc3a67.svg";